export default self => {
    self.urlRoute = self.$router.history.current && self.$router.history.current.fullPath || '';
}